import contentConfiguration from '@/configurations/content'
import viewConfiguration from '@/configurations/view'

export default {
  view: viewConfiguration,
  content: contentConfiguration
}
